module.exports = __webpack_public_path__ + "static/media/followup.cd21508b.svg";